export default __webpack_public_path__ + "static/media/smallVideo.06264a02.mp4";